<template>
	<div class="cangpin-account">
		<div class="set-list">
			<div class="set-item">
				<div class="item-name">头像</div>
				<div class="item-r">
					<img :src="thumb ? ($publicData.withHttpStart(thumb) ? thumb : imageUrl+thumb) : $publicData.defaultTouxiang " alt="" class="user-thumb">
				</div>
			</div>
			<div class="set-item">
                <div class="item-name">昵称</div>
                <div class="item-r">
                    <div class="user-name">{{ nickname }}</div>
                </div>
            </div>
			<div class="set-item">
                <div class="item-name">手机</div>
                <div class="item-r">
                    <div class="user-name">{{ phone }}</div>
                </div>
            </div>
			<div class="set-item" @click="showBindWechat = true;">
                <div class="item-name">绑定微信</div>
                <div class="item-r">
					<img :src="publicPath+'statics/images/cangpin/wechat-login.png'" alt="" class="icon-wechat">
				</div>
            </div>
		</div>
		<!-- 绑微信 -->
		<van-dialog v-model="showBindWechat" title="确定绑定微信吗？" show-cancel-button @confirm="bindWechat" @cancel="showBindWechat=false">
		</van-dialog>
	</div>
</template>
<script>
import {
    LOGOUT,
    LOGIN
} from "@/vuex/mutation_types"
export default {
	data(){
		return{
			token: null,
			thumb: null,
			nickname: null,
			phone: null,
			showBindWechat: false,
			getCodeUrl: this.$publicData.domain+'/home/wx-code?url=/cangpin/account',
			imageUrl: this.$publicData.uploadImage,
			publicPath: process.env.BASE_URL
		}
	},
	created() {
		let that = this;
		this.token = this.$store.getters.token;
		let code = this.getUrlCode()["code"];
		if(code){
			// 绑微信
			let params = {
				token: this.token,
				code: code
			};
			this.$api.user.bindWX(params).then(res=>{
				if (res.code == 200){
					// 退出 需重新登录
					this.$store.commit(LOGOUT);
					this.$router.push('/cangpin/login');
				}
			})
		}else{
			this.geUserInfo();
		}
	},
	methods: {
		/**
		 * @name: 
		 * @return {*}
		 * @desc: 
		 */		
		geUserInfo(){
			let params = {
				token: this.token
			};
			this.$api.user.index(params).then(res=>{
				if(res.code == 200){
					this.phone = res.result.info.users.username;
                    this.thumb = res.result.info.thumb;
					this.nickname = res.result.info.nickname;
				}
			})
		},
		/**
		 * @name: 绑微信
		 * @return {*}
		 * @desc: 
		 */		
		bindWechat(){
			window.location.href = this.getCodeUrl;
		},
		/**
		 * @name: 截取url中的code方法
		 * @return {*}
		 * @desc: 
		 */		
		getUrlCode() {
            var allUrl = location.href;
            var url = allUrl.substring(allUrl.indexOf("?"), allUrl.length);
            this.winUrl = url;
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                var str = url.substr(1);
                var strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
                }
            }
            return theRequest;
        },
	},
}
</script>
<style scoped>
	.cangpin-account{
		padding-top: 0.4rem;
	}
	.cangpin-account .set-list{
		padding: 0 0.53rem 0.53rem;
	}
	.cangpin-account .set-list .set-item{
		padding-top: 0.4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: .4rem;
		color: #999999;
	}
	.cangpin-account .set-item .item-r{
		color: #0E0E0E;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.cangpin-account .set-item .user-thumb{
		width: 1.6rem;
		height: 1.6rem;
		border-radius: 50%;
	}
	.cangpin-account .set-item .icon-wechat{
		width: 0.53rem;
	}
</style>